// Sliders

import Swiper from 'swiper';

document.onreadystatechange = function () {
  if (document.readyState === 'complete') {
    // Home Page Hero Slider
    if (document.querySelector('.hero-swiper-container') !== null) {
      let homeHeroSlider = new Swiper('.hero-swiper-container', {
        speed: 450,
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        threshold: 20,
        touchMoveStopPropagation: true,
        touchStartPreventDefault: true,
        navigation: {
          nextEl: '.hero-swiper-button-next-arrow',
          prevEl: '.hero-swiper-button-prev-arrow',
        },
        autoplay: {
          delay: 6000
        },
        pagination: {
          type: 'bullets',
          el: '.hero-swiper-pagination',
          bulletElement: 'span',
          clickable: true
        }
      });

      document.querySelector('.hero-swiper-container .hero-swiper-button-prev-arrow').addEventListener('click', e => {
        homeHeroSlider.slidePrev(450, true);
      });

      document.querySelector('.hero-swiper-container .hero-swiper-button-next-arrow').addEventListener('click', e => {
        homeHeroSlider.slideNext(450, true);
      });
    }

    // Articles Slider (used for related posts as well)
    let allSlides = document.querySelectorAll( '.articles-swiper-container' );
    console.log( allSlides );
    let slideArrowNext = document.querySelectorAll( '.articles-swiper-button-next-arrow' );
    let slideArrowPrev = document.querySelectorAll( '.articles-swiper-button-prev-arrow' );
    slideArrowNext.forEach( function( slideArrow, index ) {
      slideArrow.classList.add( `articles-swiper-button-next-arrow--${index}` );
    } );
    slideArrowPrev.forEach( function( slideArrow, index ) {
      slideArrow.classList.add( `articles-swiper-button-prev-arrow--${index}` );
    } )


    allSlides.forEach( function( slide, index ) {
      console.log( slide );


      slide.classList.add( `articles-swiper-container--${index}` );

      if (document.querySelector(`.articles-swiper-container--${index}`) !== null) {
        let articlesSwiper = new Swiper(`.articles-swiper-container--${index}`, {
          speed: 450,
          spaceBetween: 15,
          slidesPerView: 1,
          slidesPerGroup: 1,
          centeredSlides: false,
          loop: true,
          grabCursor: true,
          simulateTouch: true,
          allowTouchMove: true,
          threshold: 20,
          touchMoveStopPropagation: true,
          touchStartPreventDefault: true,
          autoplay: {
            delay: 5000
          },
          breakpointsInverse: true,
          breakpoints: {
            767: {
              slidesPerView: 3,
              slidesPerGroup: 3
            }
          },
          navigation: {
            nextEl: `.articles-swiper-button-next-arrow--${index}`,
            prevEl: `.articles-swiper-button-prev-arrow--${index}`,
          },
          pagination: {
            el: null
          }
        });
      }
    } );

    // Articles Slider (used for related posts as well)
    if (document.querySelector('.logos-swiper-container') !== null) {
      let articlesSwiper = new Swiper('.logos-swiper-container', {
        speed: 450,
        spaceBetween: 50,
        slidesPerView: 1,
        slidesPerGroup: 1,
        centeredSlides: false,
        loop: true,
        grabCursor: true,
        simulateTouch: true,
        allowTouchMove: true,
        threshold: 20,
        touchMoveStopPropagation: true,
        touchStartPreventDefault: true,
        autoplay: {
          delay: 5000
        },
        breakpointsInverse: true,
        breakpoints: {
          767: {
            slidesPerView: 4,
            slidesPerGroup: 1
          }
        },
        navigation: {
          nextEl: '.nextarrow--logos',
          prevEl: '.prevarrow--logos',
        },
        pagination: {
          el: null
        },
        autoplay: {
          delay: 3000
        }
      });
    }
    // Slider used on the Subscribe Section (parts/subscribe-section.php)
    if (document.querySelector('.journalism-swiper-container') !== null) {
      let journalismSwiper = new Swiper('.journalism-swiper-container', {
        speed: 300,
        slidesPerView: 1,
        loop: true,
        simulateTouch: false,
        allowTouchMove: false,
        effect: 'fade',
        autoplay: {
          delay: 3000
        },
      });
    }
  }
};
